import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { router } from './router';
import './i18n';
// Self-hosted fonts declared in tailwind.config.js (Inter body, Poppins
// display) — previously never loaded, so the whole site fell back to system-ui.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// Caveat: the handwritten accent beside the careers headline.
import '@fontsource/caveat/600.css';
// Playfair Display: the high-contrast serif the hero headline is set in.
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import 'leaflet/dist/leaflet.css';
import './index.css';

// Note: StrictMode removed due to compatibility issue with react-leaflet
// See: https://github.com/PaulLeCam/react-leaflet/issues/1052
ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>
);
